import { render, staticRenderFns } from "./StarshipDeploymentDetails.vue?vue&type=template&id=33a8dbf4&lang=pug&"
import script from "./StarshipDeploymentDetails.vue?vue&type=script&lang=ts&"
export * from "./StarshipDeploymentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports